<script setup>
import localise from "../../lang/localize.json";
import {ref} from "vue";

const props = defineProps({
  lang: {
    type: String,
    default: 'de'
  },
  header: {
    type: String,
    required: true
  }
})

const emits = defineEmits(['setnewpostext'])

const searchterm = ref('')
const setpostext = ref('')
const searchButtonText = ref(localise.btn_text_search_in_database[props.lang])
const prodListItems = ref([])
const formsent = ref(false)
const showNoResults = ref(false)

const mainHeader = props.header || localise.header_search_in_database[props.lang]

const serachProduct = () => {
  if (searchterm.value === '') return
  searchButtonText.value = localise.btn_text_searching_in_database[props.lang];
  prodListItems.value = [];
  fetch(
      'https://portal.thermo-control.com/API/v2/searchProduct.php',
      {
        method: 'POST',
        mode: 'cors',
        cache: 'no-cache',
        headers: {
          'Accept': 'application/json',
        },
        body: JSON.stringify({
          api_key: 'KAyAcRJZUacAYGRCeCfZXRAAAIQgAAEIACBxAggThJDyY0gAAEIQAACEIAABCAAgXoIIE7q',
          searchterm: searchterm.value,
          lang: props.lang
        })
      }
  ).then(response => response.json())
      .then(data => {
        if (data.status) {
          addProductData(data.products)
          showNoResults.value = false
        } else {
          showNoResults.value = true
        }
        setTimeout(() => {
          formsent.value = false;
          searchButtonText.value = localise.btn_text_newsearch_in_database[props.lang];
        }, 500)
      })

}

const addProductData = (dataListItems) => {

  for (let item of dataListItems) {
    prodListItems.value.push(
        {
          productid: item.productid,
          specification: item.specification,
          headertext: item.headertext,
          serialnumber: item.serialnumber,
          meta: {
            shopParent: item.meta.shopParent,
            shopVarante: item.meta.shopVariant,
            teid: item.meta.teid
          }
        }
    );
  }


}

const addProductToList = (id) => {

  setpostext.value = prodListItems.value[id].productid + '/' + prodListItems.value[id].specification

  if (prodListItems.value[id].serialnumber) setpostext.value = setpostext.value + localise.msg_according_sn[props.lang] + prodListItems.value[id].serialnumber

  emits('setnewpostext', setpostext.value)

}


</script>

<template>
  <main>
    <h3 class="text-lg ">{{ mainHeader }}</h3>
    <nav class="grid grid-cols-6 gap-6 items-end">

      <div class="col-span-6 lg:col-span-3">
        <label class="block text-sm font-medium"
               for="searchTerm"
        >{{ localise.input_label_search_in_database[lang] }}
        </label>
        <input v-model="searchterm"
               id="searchTerm"
               class="w-full input-md"
               :placeholder="localise.input_placeholder_find_in_database[lang]"
               type="text"
               @keydown.enter="serachProduct"
        >
      </div>

      <div class="col-span-6 lg:col-span-3">
        <button class="button-set"
                type="button"
                @click="serachProduct"
                :aria-label="lang === 'de' ? 'In der Datenbank suchen' : 'Serach term in database' "
        ><span class="inline mx-3 text-sm">{{ searchButtonText }}</span>
          <svg class="w-3 h-3 sm:w-4 sm:h-4 text-red-600 inline mx-1"
               viewBox="0 0 512 512"
               xmlns="http://www.w3.org/2000/svg"
          ><!--! Font Awesome Pro 6.3.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
            <path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"
                  style="fill:currentColor"
            />
          </svg>
        </button>
      </div>

    </nav>

    <section class="mt-4 flow-root">

      <h4 class="text-sm text-slate-300 mt-3 lg:mt-10"
          v-if="prodListItems.length===1"
      >{{ prodListItems.length }} {{ localise.dbsearch_msg_single_result[lang] }}</h4>
      <h4 class="text-sm text-slate-300 mt-3 lg:mt-10"
          v-if="prodListItems.length>1"
      >{{ prodListItems.length }} {{ localise.dbsearch_msg_multi_result[lang] }}</h4>

      <aside v-if="showNoResults"
             class="bg-yellow-50 p-4 lg:p-10 text-center align-middle"
      >
        {{ localise.dbsearch_msg_empty_result_list[lang] }}
      </aside>

      <div class="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">

        <div v-show="prodListItems.length>0"
             class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8 border-slate-100 border max-h-96 overflow-y-auto"
        >
          <table class="min-w-full divide-y">
            <tr>
              <th class="text-left">{{ localise.table_select_header_matstamm[lang] }}</th>
              <th class="text-left hidden sm:table-cell">{{ localise.table_select_header_matchcode[lang] }}</th>
              <th class="text-left hidden md:table-cell">{{ localise.table_select_header_description[lang] }}</th>
              <th class="text-left">{{ localise.table_select_header_meta[lang] }}</th>
              <th class="text-left hidden md:table-cell"></th>
            </tr>
            <tr v-for="(item, index) in prodListItems"
                :key="index"
            >

              <td class="py-1.5">
                <span :title="localise.table_select_header_description[lang]"
                      class="block"
                >{{ item.productid }}</span>
                <button type="button" class="sm:hidden button-set text-sm" @click="addProductToList(index)">
                    {{ item.headertext }}
                  </button>
              </td>
              <td class="py-1.5 text-left hidden sm:table-cell">{{ item.specification }}</td>
              <td class="py-1.5 text-left hidden md:table-cell">{{ item.headertext }}</td>
              <td class="py-1.5 text-left flex items-center space-x-1.5">
                  <span v-show="item.serialnumber" class=" flex items-center ">
                    <svg class="h-4 w-4 text-red-600 inline"
                         title="Seriennummer"
                         viewBox="0 0 448 512"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M181.3 32.4c17.4 2.9 29.2 19.4 26.3 36.8L197.8 128h95.1l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3s29.2 19.4 26.3 36.8L357.8 128H416c17.7 0 32 14.3 32 32s-14.3 32-32 32H347.1L325.8 320H384c17.7 0 32 14.3 32 32s-14.3 32-32 32H315.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8l9.8-58.7H155.1l-11.5 69.3c-2.9 17.4-19.4 29.2-36.8 26.3s-29.2-19.4-26.3-36.8L90.2 384H32c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l21.3-128H64c-17.7 0-32-14.3-32-32s14.3-32 32-32h68.9l11.5-69.3c2.9-17.4 19.4-29.2 36.8-26.3zM187.1 192L165.8 320h95.1l21.3-128H187.1z"
                            style="fill:currentColor"
                      /></svg>
                    <span v-text="item.serialnumber"></span>
                  </span>
                <i v-show="item.meta.teid"
                      title="TE_iD verfügbar"
                >
                      <svg class="h-4 w-4 text-red-600"
                           viewBox="0 0 448 512"
                           xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M0 80C0 53.5 21.5 32 48 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V80zM64 96v64h64V96H64zM0 336c0-26.5 21.5-48 48-48h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V336zm64 16v64h64V352H64zM304 32h96c26.5 0 48 21.5 48 48v96c0 26.5-21.5 48-48 48H304c-26.5 0-48-21.5-48-48V80c0-26.5 21.5-48 48-48zm80 64H320v64h64V96zM256 304c0-8.8 7.2-16 16-16h64c8.8 0 16 7.2 16 16s7.2 16 16 16h32c8.8 0 16-7.2 16-16s7.2-16 16-16s16 7.2 16 16v96c0 8.8-7.2 16-16 16H368c-8.8 0-16-7.2-16-16s-7.2-16-16-16s-16 7.2-16 16v64c0 8.8-7.2 16-16 16H272c-8.8 0-16-7.2-16-16V304zM368 480a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm64 0a16 16 0 1 1 0-32 16 16 0 1 1 0 32z"
                              style="fill:currentColor"
                        /></svg>
                </i>
                <i v-show="item.meta.shopParent"
                      title="Im Webshop verfügbar"
                   class="mt-1.5"
                >
                    <svg class="h-4 w-4 text-red-600"
                         viewBox="0 0 576 512"
                         xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"
                            style="fill:currentColor"
                      />
                    </svg>
                </i>
                <i v-show="!item.meta.teid && !item.meta.shopParent && !item.meta.shopVarante && !item.serialnumber"
                      title="No meta found"
                   class="mt-1.5"
                ><svg xmlns="http://www.w3.org/2000/svg"
                       class="h-4 w-4 text-slate-400"
                       viewBox="0 0 384 512"
                  ><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"
                                                                                                                                                                                style="fill:currentColor"
                  /></svg>
                  </i>
              </td>
              <td class="py-1.5 text-left hidden md:table-cell">
                <button class="button-add"
                        type="button"
                        @click="addProductToList(index)"
                >
                  <svg class="w-3 h-3 sm:w-4 sm:h-4 text-red-500"
                       viewBox="0 0 448 512"
                       xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M32 64C14.3 64 0 49.7 0 32S14.3 0 32 0l96 0c53 0 96 43 96 96l0 306.7 73.4-73.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3l-128 128c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 402.7 160 96c0-17.7-14.3-32-32-32L32 64z"
                          style="fill:currentColor"
                    />
                  </svg>
                </button>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </section>

  </main>
</template>

<style scoped>

</style>